import { useCallback } from 'react';
import analyticsManager from './analyticsManager';

export const useAnalytics = () => {
  const track = useCallback((eventName, eventData = {}) => {
    analyticsManager.track(eventName, eventData);
  }, []);

  const trackBatch = useCallback((events) => {
    analyticsManager.trackBatch(events);
  }, []);

  const trackPage = useCallback((path) => {
    analyticsManager.trackPage(path);
  }, []);

  const trackButton = useCallback((buttonName, location) => {
    analyticsManager.track('button_click', {
      category: 'Button',
      label: buttonName,
      location
    });
  }, []);

  const trackForm = useCallback((formName, action, data = {}) => {
    analyticsManager.track('form_submit', {
      category: 'Form',
      label: formName,
      action,
      ...data
    });
  }, []);

  const trackNavigation = useCallback((from, to) => {
    analyticsManager.track('navigation', {
      category: 'Navigation',
      label: `${from} to ${to}`
    });
  }, []);

  const trackScroll = useCallback((depth) => {
    analyticsManager.track('scroll', {
      category: 'Scroll',
      label: `${depth}%`
    });
  }, []);

  const trackExternal = useCallback((url) => {
    analyticsManager.track('external_link', {
      category: 'External Link',
      label: url
    });
  }, []);

  const trackWaitlist = useCallback((source) => {
    analyticsManager.track('waitlist_signup', {
      category: 'Waitlist',
      label: source
    });
  }, []);

  const trackContact = useCallback((formType, success) => {
    analyticsManager.track('contact', {
      category: 'Contact',
      label: formType,
      success
    });
  }, []);

  const trackPortfolio = useCallback((action, item) => {
    analyticsManager.track('portfolio', {
      category: 'Portfolio',
      label: item,
      action
    });
  }, []);

  const trackAccessibility = useCallback((toolName, action) => {
    analyticsManager.track('accessibility', {
      category: 'Accessibility',
      label: toolName,
      action
    });
  }, []);

  return {
    track,
    trackBatch,
    trackPage,
    trackButton,
    trackForm,
    trackNavigation,
    trackScroll,
    trackExternal,
    trackWaitlist,
    trackContact,
    trackPortfolio,
    trackAccessibility
  };
}; 